import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUserManagerLevel, selectIsAllowCoachingActionModel, selectIsManagerRecentApprover } from '../../pages/login/authSlice';
import { ROLES } from '../../constants';
import { AgentLandingPage } from '../../features/landingPage/agentLandingPage/AgentLandingPage';
import { TeamLeadLandingPage } from '../../features/landingPage/teamLeadLandingPage/TeamLeadLandingPage';
import './landingPage.scss';
import { ManagerLandingPage } from '../../features/landingPage/managerLandingPage/ManagerLandingPage';

export const LandingPage = () => {
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const isUserRecentApprover = useSelector(selectIsManagerRecentApprover);
    const isUserAllowCoachingAction = useSelector(selectIsAllowCoachingActionModel);

    if (userManagerLevel && ROLES.Agents.includes(userManagerLevel)) {
        return <AgentLandingPage />;
    } else if (userManagerLevel && ROLES.Supervisor.includes(userManagerLevel)) {
        return <TeamLeadLandingPage />;
    } else if(userManagerLevel && ((ROLES.OnlyManager.includes(userManagerLevel) && (isUserRecentApprover||isUserAllowCoachingAction)) || ROLES.DirectorOrAbove.includes(userManagerLevel))){ 
        return <ManagerLandingPage />;
    }
    return null;
};
